<template>
    <div>
        <el-container class="toolBar">
            <el-main style="overflow-y: hidden;padding-bottom: 10px">
                <div >
                    <el-form :inline="true" style="text-align: left;padding-left:10px;" label-width="100px">
                        <div>
                            <el-form-item>
                                <el-button icon="el-icon-monitor" type="primary" size="medium" @click="systeminit">
                                    系统初始化
                                </el-button>
                                <el-button icon="el-icon-search" type="primary" size="medium" @click="search">
                                    查询
                                </el-button>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="Xdriver"></div>
            </el-main>
        </el-container>
    </div>
</template>

<script>


    export default {
        name: 'toolBar',
        props: ['menuId', 'toolHeight', 'loading'],
        components: {
        },
        data() {
            return {
                searBarHeight: 70,
                yearMonth:""
            }
        },
        methods: {
            search() {

                let searchData = {}
                this.$emit('search',searchData);
            },
            systeminit() {
                let searchData = {}
                this.$emit('initialSystem',searchData);
            },
        }
    }
</script>

